import {
  ApiBlueprint,
  createFrontendPlugin,
  PageBlueprint,
  storageApiRef,
} from '@backstage/frontend-plugin-api';

import { onboardingApiRef } from './api/OnboardingApi';
import { OnboardingApiClient } from './api/OnboardingApiClient';
import { rootRouteRef } from './routes';

const onboardingApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: onboardingApiRef,
      deps: { storageApi: storageApiRef },
      factory: ({ storageApi }) => new OnboardingApiClient({ storageApi }),
    }),
});

const onboardingPage = PageBlueprint.make({
  params: {
    path: '/onboarding',
    routeRef: rootRouteRef,
    // These pages render their own Header; suppress the default plugin page header.
    noHeader: true,
    loader: () =>
      import('./components/OnboardingPage').then(m => <m.OnboardingPage />),
  },
});

export default createFrontendPlugin({
  pluginId: 'new-starter-onboarding',
  routes: {
    root: rootRouteRef,
  },
  extensions: [onboardingApi, onboardingPage],
});
